<template>
  <span class="button-loader">
    <b-spinner
      style="width: 19px; height: 19px"
      variant="light"
      label="Loading"
    />
  </span>
</template>
<script>
export default {
  name: 'ButtonLoader',
};
</script>
